import React from "react";

function ErrorPage() {
  return (
    <div>
      <h2>500</h2>
      <p>Something went wrong!</p>
    </div>
  );
}

export default ErrorPage;
